<template>
  <LoadingVue :active="showLoader && !menuLoaded && !isHandlingHubAccessRequired" :is-full-page="true" :z-index="1100" />
  <router-view />
  <button id="RFID_modal_btn" class="d-none" data-bs-toggle="modal" data-bs-target="#kt_modal_RFID"></button>
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";
import { defineRule } from "vee-validate";
import { required } from "@vee-validate/rules";
import { useRouter } from "vue-router";
import { useMenuStore } from "./store/menu";
import { useAppStore } from "./store/appStore";
import { alertFailed } from "./functions/swAlert";
import { msalInstance } from "./authConfig";
import { getIsHandlingHubAccessRequired, getIsHandlingSessionExpired, isHandlingHubAccessRequired } from "./utils/authToken";
import LoadingVue from "vue3-loading-overlay";

const LANDING_PREFERRED_ROUTE = "/tornei";
export default defineComponent({
  name: "app",
  components: {},
  setup() {
    const store = useStore();
    const router = useRouter();
    const storeMenu = useMenuStore();
    const appStore = useAppStore();
    const { loaded: menuLoaded } = storeToRefs(storeMenu);
    // Controlla la visibilità del loader full-page indipendentemente da menuLoaded, così
    // possiamo spegnerlo prima di mostrare l'alert di errore (altrimenti resta sopra).
    const showLoader = ref(true);

    storeMenu.load();

    onMounted(async () => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
      nextTick(() => {
        initializeComponents();
      });
      defineRule("required", required);

      document.addEventListener("show.bs.dropdown", function () {
        const trs = document.querySelectorAll("tr:not(.modal tr)");
        const dropdownButtons = document.querySelectorAll(".bi-three-dots-vertical");
        const dropdownButtonsDownload = document.querySelectorAll(".bi-cloud-download");
        const dropdownButtonsAll = Array.prototype.slice
          .call(dropdownButtons)
          .concat(Array.prototype.slice.call(dropdownButtonsDownload))
          .sort((a, b) => {
            if (a === b) {
              return 0;
            }
            const position = a.compareDocumentPosition(b);
            if (position & Node.DOCUMENT_POSITION_PRECEDING) {
              return 1;
            }
            if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
              return -1;
            }
            return 0;
          });
        const dropdownMenus = document.querySelectorAll(".dropdown-menu");
        if (trs.length < 9) {
          trs.forEach((element, index) => {
            dropdownMenus.forEach((dropdown, indexdd) => {
              dropdownButtonsAll.forEach((dots, indexdots) => {
                if (dropdown.closest(".modal")) {
                  return; // Salta l'elaborazione per i dropdown nei modali
                }
                const position = () => {
                  dropdown.classList.add("position-fixed");
                  const elementPosition = element.getBoundingClientRect();
                  var style = document.createElement("style");
                  style.type = "text/css";
                  style.innerHTML = `.dropdown-transform${index} { transform: translate3d(-56px, 45px, 0px) !important; inset: ${elementPosition.y}px 0px auto auto!important;  left:${elementPosition.x}px; top: ${elementPosition.y}px`;

                  document.getElementsByTagName("head")[0].appendChild(style);

                  dropdown.classList.add(`dropdown-transform${index}`);
                };
                if (indexdd === index - 1 && indexdots === index - 1) {
                  document.addEventListener("scroll", position, true);
                  position();
                }
              });
            });
          });
        }
      });

      await storeMenu.load();

      if (storeMenu.isEmpty) {
        showLoader.value = false;
        if (getIsHandlingHubAccessRequired() || getIsHandlingSessionExpired()) return;
        await alertFailed("Impossibile caricare il menu. Si verrà reindirizzati al login.");
        msalInstance.logoutRedirect();
        return;
      }

      // Precarica le discipline (fonte di verità /v1/Lookup/Discipline/list) una sola volta, solo
      // DOPO il caricamento del menu: così il token fresco è già stato scritto da storeMenu.load()
      // (vedi ensureFreshToken) e il BE non blocca la richiesta come utente non autorizzato.
      if (!appStore.discipline) appStore.getAllDiscipline();

      await router.isReady();
      if (router.currentRoute.value.path === "/") {
        const landing = storeMenu.isRouteAuthorized(LANDING_PREFERRED_ROUTE) ? LANDING_PREFERRED_ROUTE : storeMenu.firstAvailableRoute;
        if (landing) router.replace(landing);
      }
    });

    return {
      menuLoaded,
      showLoader,
      isHandlingHubAccessRequired,
    };
  },
});
</script>

<style lang="scss">
@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "~apexcharts/dist/apexcharts.css";
@import "~quill/dist/quill.snow.css";
@import "~animate.css";
@import "~sweetalert2/dist/sweetalert2.css";
@import "~nouislider/distribute/nouislider.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~socicon/css/socicon.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "~dropzone/dist/dropzone.css";
@import "~@vueform/multiselect/themes/default.css";
@import "~prism-themes/themes/prism-shades-of-purple.css";
@import "~element-plus/dist/index.css";
@import "@vuepic/vue-datepicker/dist/main.css";

// Main demo style scss
@import "assets/sass/plugins";
@import "assets/sass/style";
</style>
